<template>
  <div class="vzan-subscribe">
    <slot></slot>
    <wx-open-subscribe
      style="position: absolute; width: 100%; height: 100%; top: 0; left: 0"
      :template="template"
      @success="onAccept"
    >
      <component :is="'script'" type="text/wxtag-template">
        <component :is="'style'">
          .ghost-btn { border: none; position:absolute; z-index:2; opacity: 0;
          left:0;top:0; right:0; bottom:0; width:100%; height:100%; }
        </component>
        <button class="ghost-btn"></button>
      </component>
    </wx-open-subscribe>
  </div>
</template>

<script>
export default {
  name: 'Index',
  props: {
    template: String,
  },
  methods: {
    onAccept(event) {
      this.$emit('accept', event)
    },
  },
}
</script>

<style scoped lang="scss">
.vzan-subscribe {
  display: inline-flex;
  position: relative;
}
</style>
